<div class="chat_bot">
    <div class="chat-room" [ngClass]="{'opened': showChatbot==true}">
        <div class="chat-header">
            <div class="header_logo"><img [src]="image_URL+'chatbot-icon.png'" alt=""></div>
            <span>Odyssey</span>
            <button (click)="showChatbot=!showChatbot">
                <i class="icon-close"></i>
            </button>
        </div>
        <div class="chat-body" id="chat_time_scroll_pos_bottom">
            <div *ngFor="let answer of answers; let last = last">
                <div *ngIf="answer.isWeather==1">
                    <div class="chat-msg weather" [ngClass]="{'sunny': text=='sunny', 'rainy': text=='rainy', 'cloudy': text=='cloudy', 'stormy': text=='Thunderstorms'}">
                        <p class="loc">{{answer.speech.city}}</p>
                        <p class="date">
                            <small>{{answer.speech.date}}</small>
                        </p>
                        <div class="weather-data">
                            <div class="text-info">
                                <h2>{{answer.speech.temp}}
                                    <sup>0</sup>C</h2>
                                <p>
                                    <span>high : {{answer.speech.high}}
                                        <sup>0</sup>C</span>
                                </p>
                                <p>
                                    <span>low : {{answer.speech.low}}
                                        <sup>0</sup>C</span>
                                </p>
                            </div>
                            <div class="img-info">
                                <img [src]="image_URL+'sky.png'" *ngIf="text!='sunny' && text!='rainy' && text!='cloudy' && text!='Thunderstorms'" alt="">
                                <img [src]="image_URL+'sun.png'" *ngIf="text=='sunny'" alt="">
                                <img [src]="image_URL+'rain.png'" *ngIf="text=='rainy'" alt="">
                                <img [src]="image_URL+'rainbow.png'" *ngIf="text=='cloudy'" alt="">
                                <img [src]="image_URL+'lightning.png'" *ngIf="text=='Thunderstorms'" alt="">
                                <p>{{answer.speech.text}}</p>
                            </div>
                        </div>
                        {{last ? scroll_ele() : ''}}
                    </div>
                </div>
                <div *ngIf="answer.type==1" class="right">
                    <div class="chat-msg">
                        {{answer.speech}} {{last ? scroll_ele() : ''}}
                    </div>
                </div>
                <div class="chat-msg" *ngIf="answer.type==0 && answer.isWeather!=1">
                    <div *ngIf="answer.isUrl==-1 && answer.isBtn==-1"> {{answer.speech}}</div>
                    <div *ngIf="answer.isUrl!=-1" class="btnBox">
                        {{answer.speech.split('~')[2]}}
                        <!-- answer.speech.substring(4, answer.speech.length) -->
                        <a href="{{answer.speech.split('~')[0].substring(4,answer.speech.split('~')[0].length)}}" class="btn" target="_blank">{{answer.speech.split('~')[1]}}</a>
                        <!-- <a *ngIf="loginType==2" href="{{loginUrl}}" target="_blank">{{answer.speech.substring(4, answer.speech.length)}}</a> -->
                    </div>
                    <div *ngIf="answer.isBtn!=-1 && answer.isUrl==-1">
                        <div> {{answer.speech}}</div>
                        <div class="btnBox" *ngIf="answer.btnObj">
                            <ng-container *ngFor="let dta of answer.btnObj,let i = index">
                                <button *ngIf="i>0" class="btn" (click)="ask(dta,1)">{{dta}}</button>
                            </ng-container>
                        </div>
                    </div>


                    {{last ? scroll_ele() : ''}}
                    <!-- <span *ngIf="answer.speech.search(" url ")!=-1">{{answer.speech.substring(4, answer.speech.length)}}</span> -->
                    <!-- {{answer.speech}} -->
                </div>

            </div>
            <div class="chat-msg" *ngIf="typing==1">
                <img [src]="image_URL+'loading.gif'" height="22px" alt=""> {{last ? scroll_ele() : ''}}
            </div>

        </div>
        <div class="chat-footer">
            <!-- <p *ngIf="typing==1" class="typing">Agent is typing...</p> -->
            <input placeholder="{{placeholder}}" autofocus (keyup.enter)="entClicked($event)" type="{{type}}" [(ngModel)]="textValue">
            <!-- <input #textbox *ngIf="btnActive=='1'" [disabled]="true"> -->
            <!-- <input *ngIf="passIsActive=='1'" id="textboxPass" placeholder="Enter Password"  [autofocus]="true" (keyup.enter)="entClicked($event)"
                type="password" [(ngModel)]="textValue"> -->
            <button *ngIf="passIsActive=='0'" (click)="ask(textValue,1)" type="button">
                <img [src]="image_URL+'paper-plane.png'" width="26px" alt="">
                <!-- <i class="icon-send-msg"></i> -->
            </button>
            <button *ngIf="passIsActive=='1'" (click)="ask(textValue,0)" type="button">
                <img [src]="image_URL+'paper-plane.png'" alt="" width="26px">
                <!-- <i class="icon-send-msg"></i> -->
            </button>


        </div>
    </div>
    <button type="button" class="fab-btn" (click)="callBot()">
        <!-- <i class="icon-chat"></i> showChatbot=!showChatbot-->
        <img [src]="image_URL+'chatbot-icon.png'" alt="">
    </button>
</div>